// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../AuthContext";
// import { Home, Settings as SettingsIcon, Save } from "lucide-react";

// const Settings = () => {
//   const navigate = useNavigate();
//   const { isAuthenticated, logout, user } = useAuth();
  
//   const [imageScaling, setImageScaling] = useState(0.5);
//   const [isSaved, setIsSaved] = useState(false);

//   useEffect(() => {
//     if (!isAuthenticated()) {
//       navigate("/login");
//       return;
//     }

//     // Load saved scaling value from localStorage
//     const savedScaling = localStorage.getItem("imageScaling");
//     if (savedScaling) {
//       const scalingValue = parseFloat(savedScaling);
//       if (!isNaN(scalingValue) && scalingValue >= 0.1 && scalingValue <= 1.0) {
//         setImageScaling(scalingValue);
//       }
//     }
//   }, [navigate, isAuthenticated]);

//   const handleScalingChange = (e) => {
//     const value = parseFloat(e.target.value);
//     setImageScaling(value);
//     setIsSaved(false);
//   };

//   const handleSave = () => {
//     localStorage.setItem("imageScaling", imageScaling.toString());
//     setIsSaved(true);
//     setTimeout(() => setIsSaved(false), 3000);
//   };

//   const handleReset = () => {
//     setImageScaling(0.5);
//     localStorage.setItem("imageScaling", "0.5");
//     setIsSaved(true);
//     setTimeout(() => setIsSaved(false), 3000);
//   };

//   return (
//     <div className="min-h-screen bg-gray-100">
//       {/* Header */}
//       <div className="bg-white shadow-sm border-b border-gray-200">
//         <div className="max-w-4xl mx-auto px-6 py-4">
//           <div className="flex items-center justify-between">
//             <div className="flex items-center gap-3">
//               <SettingsIcon className="w-6 h-6 text-gray-700" />
//               <h1 className="text-2xl font-semibold text-gray-800">Settings</h1>
//             </div>
//             <div className="flex items-center gap-3">
//               {user && (
//                 <span className="text-sm text-gray-600">{user.email}</span>
//               )}
//               <button
//                 onClick={() => navigate("/")}
//                 className="flex items-center gap-2 px-4 py-2 text-sm bg-gray-500 hover:bg-gray-600 text-white rounded transition-colors"
//                 title="Back to Home"
//               >
//                 <Home className="w-4 h-4" />
//                 Home
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Success Notification */}
//       {isSaved && (
//         <div className="fixed top-4 right-4 bg-green-500 text-white px-6 py-3 rounded-lg shadow-lg z-50 flex items-center gap-2 animate-fade-in">
//           <Save className="w-5 h-5" />
//           Settings saved successfully!
//         </div>
//       )}

//       {/* Settings Content */}
//       <div className="max-w-4xl mx-auto px-6 py-8">
//         <div className="bg-white rounded-lg shadow-md p-6">
//           <h2 className="text-xl font-semibold text-gray-800 mb-6">
//             Image Display Settings
//           </h2>

//           {/* Image Scaling Setting */}
//           <div className="space-y-6">
//             <div className="border-b border-gray-200 pb-6">
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Default Image Scaling (Low-Res Mode)
//               </label>
//               <p className="text-sm text-gray-500 mb-4">
//                 Adjust the default scaling for images when viewing in low-res mode. 
//                 Lower values load faster but with reduced quality.
//               </p>

//               {/* Slider */}
//               <div className="space-y-4">
//                 <div className="flex items-center gap-4">
//                   <span className="text-sm text-gray-600 min-w-[60px]">
//                     10%
//                   </span>
//                   <input
//                     type="range"
//                     min="0.1"
//                     max="1.0"
//                     step="0.1"
//                     value={imageScaling}
//                     onChange={handleScalingChange}
//                     className="flex-1 h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-blue-500"
//                     style={{
//                       background: `linear-gradient(to right, #3b82f6 0%, #3b82f6 ${
//                         ((imageScaling - 0.1) / 0.9) * 100
//                       }%, #e5e7eb ${((imageScaling - 0.1) / 0.9) * 100}%, #e5e7eb 100%)`,
//                     }}
//                   />
//                   <span className="text-sm text-gray-600 min-w-[60px]">
//                     100%
//                   </span>
//                 </div>

//                 {/* Current Value Display */}
//                 <div className="flex items-center justify-between bg-blue-50 border border-blue-200 rounded-lg p-4">
//                   <div>
//                     <p className="text-sm font-medium text-gray-700">
//                       Current Scaling
//                     </p>
//                     <p className="text-xs text-gray-500 mt-1">
//                       {imageScaling < 0.3 && "Fastest loading, lowest quality"}
//                       {imageScaling >= 0.3 && imageScaling < 0.6 && "Balanced speed and quality"}
//                       {imageScaling >= 0.6 && imageScaling < 0.9 && "Slower loading, better quality"}
//                       {imageScaling >= 0.9 && "Slowest loading, best quality"}
//                     </p>
//                   </div>
//                   <div className="text-right">
//                     <p className="text-3xl font-bold text-blue-600">
//                       {Math.round(imageScaling * 100)}%
//                     </p>
//                     <p className="text-xs text-gray-500">
//                       ({imageScaling.toFixed(1)}x)
//                     </p>
//                   </div>
//                 </div>

//                 {/* Quick Presets */}
//                 <div className="flex gap-2 flex-wrap">
//                   <button
//                     onClick={() => {
//                       setImageScaling(0.3);
//                       setIsSaved(false);
//                     }}
//                     className={`px-3 py-1.5 text-sm rounded transition-colors ${
//                       imageScaling === 0.3
//                         ? "bg-blue-500 text-white"
//                         : "bg-gray-100 text-gray-700 hover:bg-gray-200"
//                     }`}
//                   >
//                     Fast (30%)
//                   </button>
//                   <button
//                     onClick={() => {
//                       setImageScaling(0.5);
//                       setIsSaved(false);
//                     }}
//                     className={`px-3 py-1.5 text-sm rounded transition-colors ${
//                       imageScaling === 0.5
//                         ? "bg-blue-500 text-white"
//                         : "bg-gray-100 text-gray-700 hover:bg-gray-200"
//                     }`}
//                   >
//                     Balanced (50%)
//                   </button>
//                   <button
//                     onClick={() => {
//                       setImageScaling(0.7);
//                       setIsSaved(false);
//                     }}
//                     className={`px-3 py-1.5 text-sm rounded transition-colors ${
//                       imageScaling === 0.7
//                         ? "bg-blue-500 text-white"
//                         : "bg-gray-100 text-gray-700 hover:bg-gray-200"
//                     }`}
//                   >
//                     Quality (70%)
//                   </button>
//                   <button
//                     onClick={() => {
//                       setImageScaling(1.0);
//                       setIsSaved(false);
//                     }}
//                     className={`px-3 py-1.5 text-sm rounded transition-colors ${
//                       imageScaling === 1.0
//                         ? "bg-blue-500 text-white"
//                         : "bg-gray-100 text-gray-700 hover:bg-gray-200"
//                     }`}
//                   >
//                     Maximum (100%)
//                   </button>
//                 </div>
//               </div>
//             </div>

//             {/* Info Box */}
//             <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
//               <h3 className="text-sm font-medium text-yellow-800 mb-2">
//                 ℹ️ Note
//               </h3>
//               <ul className="text-sm text-yellow-700 space-y-1">
//                 <li>• This setting only affects low-res mode (default view)</li>
//                 <li>• High-res mode always displays images at 100% quality</li>
//                 <li>• Changes take effect for newly loaded images</li>
//                 <li>• Lower scaling = faster loading, less bandwidth usage</li>
//               </ul>
//             </div>

//             {/* Action Buttons */}
//             <div className="flex gap-3 pt-4">
//               <button
//                 onClick={handleSave}
//                 className="flex items-center gap-2 px-6 py-2.5 bg-blue-500 hover:bg-blue-600 text-white rounded-lg font-medium transition-colors"
//               >
//                 <Save className="w-4 h-4" />
//                 Save Settings
//               </button>
//               <button
//                 onClick={handleReset}
//                 className="px-6 py-2.5 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-lg font-medium transition-colors"
//               >
//                 Reset to Default (50%)
//               </button>
//             </div>
//           </div>
//         </div>


//       </div>
//     </div>
//   );
// };

// export default Settings;


///////////////////////////////////////////////////////////////////// added component for user to select prefetch count
// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../AuthContext";
// import { Home, Settings as SettingsIcon, Save } from "lucide-react";

// const Settings = () => {
//   const navigate = useNavigate();
//   const { isAuthenticated, logout, user } = useAuth();
  
//   const [imageScaling, setImageScaling] = useState(0.3);
//   const [prefetchCount, setPrefetchCount] = useState(3);
//   const [isSaved, setIsSaved] = useState(false);

//   useEffect(() => {
//     if (!isAuthenticated()) {
//       navigate("/login");
//       return;
//     }

//     // Load saved scaling value from localStorage
//     const savedScaling = localStorage.getItem("imageScaling");
//     if (savedScaling) {
//       const scalingValue = parseFloat(savedScaling);
//       if (!isNaN(scalingValue) && scalingValue >= 0.1 && scalingValue <= 1.0) {
//         setImageScaling(scalingValue);
//       }
//     }

//     // Load saved prefetch count from localStorage
//     const savedPrefetchCount = localStorage.getItem("prefetchCount");
//     if (savedPrefetchCount) {
//       const prefetchValue = parseInt(savedPrefetchCount);
//       if (!isNaN(prefetchValue) && prefetchValue >= 1 && prefetchValue <= 10) {
//         setPrefetchCount(prefetchValue);
//       }
//     }
//   }, [navigate, isAuthenticated]);

//   const handleScalingChange = (e) => {
//     const value = parseFloat(e.target.value);
//     setImageScaling(value);
//     setIsSaved(false);
//   };

//   const handlePrefetchCountChange = (e) => {
//     const value = parseInt(e.target.value);
//     setPrefetchCount(value);
//     setIsSaved(false);
//   };

//   const handleSave = () => {
//     localStorage.setItem("imageScaling", imageScaling.toString());
//     localStorage.setItem("prefetchCount", prefetchCount.toString());
//     setIsSaved(true);
//     setTimeout(() => setIsSaved(false), 3000);
//   };

//   const handleReset = () => {
//     setImageScaling(0.3);
//     setPrefetchCount(3);
//     localStorage.setItem("imageScaling", "0.3");
//     localStorage.setItem("prefetchCount", "3");
//     setIsSaved(true);
//     setTimeout(() => setIsSaved(false), 3000);
//   };

//   return (
//     <div className="min-h-screen bg-gray-100">
//       {/* Header */}
//       <div className="bg-white shadow-sm border-b border-gray-200">
//         <div className="max-w-4xl mx-auto px-6 py-4">
//           <div className="flex items-center justify-between">
//             <div className="flex items-center gap-3">
//               <SettingsIcon className="w-6 h-6 text-gray-700" />
//               <h1 className="text-2xl font-semibold text-gray-800">Settings</h1>
//             </div>
//             <div className="flex items-center gap-3">
//               {user && (
//                 <span className="text-sm text-gray-600">{user.email}</span>
//               )}
//               <button
//                 onClick={() => navigate("/")}
//                 className="flex items-center gap-2 px-4 py-2 text-sm bg-gray-500 hover:bg-gray-600 text-white rounded transition-colors"
//                 title="Back to Home"
//               >
//                 <Home className="w-4 h-4" />
//                 Home
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Success Notification */}
//       {isSaved && (
//         <div className="fixed top-4 right-4 bg-green-500 text-white px-6 py-3 rounded-lg shadow-lg z-50 flex items-center gap-2 animate-fade-in">
//           <Save className="w-5 h-5" />
//           Settings saved successfully!
//         </div>
//       )}

//       {/* Settings Content */}
//       <div className="max-w-4xl mx-auto px-6 py-8">
//         <div className="bg-white rounded-lg shadow-md p-6">
//           <h2 className="text-xl font-semibold text-gray-800 mb-6">
//             Image Display Settings
//           </h2>

//           {/* Image Scaling Setting */}
//           <div className="space-y-6">
//             <div className="border-b border-gray-200 pb-6">
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Default Image Scaling (Low-Res Mode)
//               </label>
//               <p className="text-sm text-gray-500 mb-4">
//                 Adjust the default scaling for images when viewing in low-res mode. 
//                 Lower values load faster but with reduced quality.
//               </p>

//               {/* Slider */}
//               <div className="space-y-4">
//                 <div className="flex items-center gap-4">
//                   <span className="text-sm text-gray-600 min-w-[60px]">
//                     10%
//                   </span>
//                   <input
//                     type="range"
//                     min="0.1"
//                     max="1.0"
//                     step="0.1"
//                     value={imageScaling}
//                     onChange={handleScalingChange}
//                     className="flex-1 h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-blue-500"
//                     style={{
//                       background: `linear-gradient(to right, #3b82f6 0%, #3b82f6 ${
//                         ((imageScaling - 0.1) / 0.9) * 100
//                       }%, #e5e7eb ${((imageScaling - 0.1) / 0.9) * 100}%, #e5e7eb 100%)`,
//                     }}
//                   />
//                   <span className="text-sm text-gray-600 min-w-[60px]">
//                     100%
//                   </span>
//                 </div>

//                 {/* Current Value Display */}
//                 <div className="flex items-center justify-between bg-blue-50 border border-blue-200 rounded-lg p-4">
//                   <div>
//                     <p className="text-sm font-medium text-gray-700">
//                       Current Scaling
//                     </p>
//                     <p className="text-xs text-gray-500 mt-1">
//                       {imageScaling < 0.3 && "Fastest loading, lowest quality"}
//                       {imageScaling >= 0.3 && imageScaling < 0.6 && "Balanced speed and quality"}
//                       {imageScaling >= 0.6 && imageScaling < 0.9 && "Slower loading, better quality"}
//                       {imageScaling >= 0.9 && "Slowest loading, best quality"}
//                     </p>
//                   </div>
//                   <div className="text-right">
//                     <p className="text-3xl font-bold text-blue-600">
//                       {Math.round(imageScaling * 100)}%
//                     </p>
//                     <p className="text-xs text-gray-500">
//                       ({imageScaling.toFixed(1)}x)
//                     </p>
//                   </div>
//                 </div>

//                 {/* Quick Presets */}
//                 <div className="flex gap-2 flex-wrap">
//                   <button
//                     onClick={() => {
//                       setImageScaling(0.3);
//                       setIsSaved(false);
//                     }}
//                     className={`px-3 py-1.5 text-sm rounded transition-colors ${
//                       imageScaling === 0.3
//                         ? "bg-blue-500 text-white"
//                         : "bg-gray-100 text-gray-700 hover:bg-gray-200"
//                     }`}
//                   >
//                     Fast (30%)
//                   </button>
//                   <button
//                     onClick={() => {
//                       setImageScaling(0.5);
//                       setIsSaved(false);
//                     }}
//                     className={`px-3 py-1.5 text-sm rounded transition-colors ${
//                       imageScaling === 0.5
//                         ? "bg-blue-500 text-white"
//                         : "bg-gray-100 text-gray-700 hover:bg-gray-200"
//                     }`}
//                   >
//                     Balanced (50%)
//                   </button>
//                   <button
//                     onClick={() => {
//                       setImageScaling(0.7);
//                       setIsSaved(false);
//                     }}
//                     className={`px-3 py-1.5 text-sm rounded transition-colors ${
//                       imageScaling === 0.7
//                         ? "bg-blue-500 text-white"
//                         : "bg-gray-100 text-gray-700 hover:bg-gray-200"
//                     }`}
//                   >
//                     Quality (70%)
//                   </button>
//                   <button
//                     onClick={() => {
//                       setImageScaling(1.0);
//                       setIsSaved(false);
//                     }}
//                     className={`px-3 py-1.5 text-sm rounded transition-colors ${
//                       imageScaling === 1.0
//                         ? "bg-blue-500 text-white"
//                         : "bg-gray-100 text-gray-700 hover:bg-gray-200"
//                     }`}
//                   >
//                     Maximum (100%)
//                   </button>
//                 </div>
//               </div>
//             </div>

//             {/* Image Prefetch Count Setting */}
//             <div className="border-b border-gray-200 pb-6">
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Image Prefetch Count
//               </label>
//               <p className="text-sm text-gray-500 mb-4">
//                 Set how many upcoming images to preload in the background. 
//                 Higher values provide smoother navigation but use more memory and bandwidth.
//               </p>

//               {/* Slider */}
//               <div className="space-y-4">
//                 <div className="flex items-center gap-4">
//                   <span className="text-sm text-gray-600 min-w-[60px]">
//                     1 image
//                   </span>
//                   <input
//                     type="range"
//                     min="1"
//                     max="10"
//                     step="1"
//                     value={prefetchCount}
//                     onChange={handlePrefetchCountChange}
//                     className="flex-1 h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-green-500"
//                     style={{
//                       background: `linear-gradient(to right, #10b981 0%, #10b981 ${
//                         ((prefetchCount - 1) / 9) * 100
//                       }%, #e5e7eb ${((prefetchCount - 1) / 9) * 100}%, #e5e7eb 100%)`,
//                     }}
//                   />
//                   <span className="text-sm text-gray-600 min-w-[60px]">
//                     10 images
//                   </span>
//                 </div>

//                 {/* Current Value Display */}
//                 <div className="flex items-center justify-between bg-green-50 border border-green-200 rounded-lg p-4">
//                   <div>
//                     <p className="text-sm font-medium text-gray-700">
//                       Current Prefetch Count
//                     </p>
//                     <p className="text-xs text-gray-500 mt-1">
//                       {prefetchCount <= 2 && "Minimal memory usage, less smooth navigation"}
//                       {prefetchCount >= 3 && prefetchCount <= 5 && "Balanced performance and memory usage"}
//                       {prefetchCount >= 6 && prefetchCount <= 8 && "Higher memory usage, smoother navigation"}
//                       {prefetchCount >= 9 && "Maximum memory usage, smoothest navigation"}
//                     </p>
//                   </div>
//                   <div className="text-right">
//                     <p className="text-3xl font-bold text-green-600">
//                       {prefetchCount}
//                     </p>
//                     <p className="text-xs text-gray-500">
//                       {prefetchCount === 1 ? "image" : "images"}
//                     </p>
//                   </div>
//                 </div>

//                 {/* Quick Presets */}
//                 <div className="flex gap-2 flex-wrap">
//                   <button
//                     onClick={() => {
//                       setPrefetchCount(1);
//                       setIsSaved(false);
//                     }}
//                     className={`px-3 py-1.5 text-sm rounded transition-colors ${
//                       prefetchCount === 1
//                         ? "bg-green-500 text-white"
//                         : "bg-gray-100 text-gray-700 hover:bg-gray-200"
//                     }`}
//                   >
//                     Minimal (1)
//                   </button>
//                   <button
//                     onClick={() => {
//                       setPrefetchCount(3);
//                       setIsSaved(false);
//                     }}
//                     className={`px-3 py-1.5 text-sm rounded transition-colors ${
//                       prefetchCount === 3
//                         ? "bg-green-500 text-white"
//                         : "bg-gray-100 text-gray-700 hover:bg-gray-200"
//                     }`}
//                   >
//                     Balanced (3)
//                   </button>
//                   <button
//                     onClick={() => {
//                       setPrefetchCount(5);
//                       setIsSaved(false);
//                     }}
//                     className={`px-3 py-1.5 text-sm rounded transition-colors ${
//                       prefetchCount === 5
//                         ? "bg-green-500 text-white"
//                         : "bg-gray-100 text-gray-700 hover:bg-gray-200"
//                     }`}
//                   >
//                     Smooth (5)
//                   </button>
//                   <button
//                     onClick={() => {
//                       setPrefetchCount(10);
//                       setIsSaved(false);
//                     }}
//                     className={`px-3 py-1.5 text-sm rounded transition-colors ${
//                       prefetchCount === 10
//                         ? "bg-green-500 text-white"
//                         : "bg-gray-100 text-gray-700 hover:bg-gray-200"
//                     }`}
//                   >
//                     Maximum (10)
//                   </button>
//                 </div>
//               </div>
//             </div>

//             {/* Info Box */}
//             <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
//               <h3 className="text-sm font-medium text-yellow-800 mb-2">
//                 ℹ️ Note
//               </h3>
//               <ul className="text-sm text-yellow-700 space-y-1">
//                 <li>• Image scaling only affects low-res mode (default view)</li>
//                 <li>• High-res mode always displays images at 100% quality</li>
//                 <li>• Prefetch count determines how many upcoming images are loaded in advance</li>
//                 <li>• Higher prefetch values improve navigation speed but use more memory</li>
//                 <li>• Changes take effect for newly loaded images</li>
//                 <li>• Lower scaling = faster loading, less bandwidth usage</li>
//               </ul>
//             </div>

//             {/* Action Buttons */}
//             <div className="flex gap-3 pt-4">
//               <button
//                 onClick={handleSave}
//                 className="flex items-center gap-2 px-6 py-2.5 bg-blue-500 hover:bg-blue-600 text-white rounded-lg font-medium transition-colors"
//               >
//                 <Save className="w-4 h-4" />
//                 Save Settings
//               </button>
//               <button
//                 onClick={handleReset}
//                 className="px-6 py-2.5 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-lg font-medium transition-colors"
//               >
//                 Reset to Defaults (30% scaling, 3 prefetch)
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Settings;

import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { Home, Settings as SettingsIcon, Save, Download, ChevronDown } from "lucide-react";
import config from "./Config/config";

// Custom RID Dropdown Component with Search
const RidDropdown = ({ ridsList, selectedRid, onSelectRid, isDisabled, isLoading }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Filter RIDs based on search term
  const filteredRids = ridsList.filter((rid) =>
    rid.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelect = (rid) => {
    onSelectRid(rid);
    setIsOpen(false);
    setSearchTerm("");
  };

  const getDisplayText = () => {
    if (isLoading) return "Loading RIDs...";
    if (!selectedRid) return "Select a RID...";
    return selectedRid;
  };

  return (
    <div className="relative" ref={dropdownRef}>
      {/* Dropdown Button */}
      <button
        type="button"
        onClick={() => !isDisabled && setIsOpen(!isOpen)}
        disabled={isDisabled}
        className={`w-full px-3 py-2.5 pr-10 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 text-sm text-left bg-white transition-colors ${
          !selectedRid && !isLoading
            ? "border-gray-300 text-gray-400"
            : "border-gray-300 text-gray-700"
        } ${
          isDisabled
            ? "bg-gray-100 cursor-not-allowed"
            : "cursor-pointer hover:border-purple-300"
        }`}
      >
        <span className="block truncate">{getDisplayText()}</span>
        <ChevronDown
          className={`absolute right-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400 transition-transform ${
            isOpen ? "rotate-180" : ""
          }`}
        />
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg">
          {/* Search Input */}
          <div className="p-2 border-b border-gray-200">
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search RIDs..."
              className="w-full px-3 py-2 text-sm border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
              autoFocus
            />
          </div>

          {/* Options List */}
          <div className="max-h-60 overflow-y-auto scrollbar-visible">
            {/* RID Options */}
            {filteredRids.length > 0 ? (
              filteredRids.map((rid) => (
                <button
                  key={rid}
                  type="button"
                  onClick={() => handleSelect(rid)}
                  className={`w-full px-4 py-2.5 text-left text-sm hover:bg-purple-50 transition-colors ${
                    selectedRid === rid
                      ? "bg-purple-100 text-purple-700 font-medium"
                      : "text-gray-700"
                  }`}
                >
                  {rid}
                </button>
              ))
            ) : (
              <div className="px-4 py-3 text-sm text-gray-500 text-center">
                No RIDs found matching "{searchTerm}"
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

const Settings = () => {
  const navigate = useNavigate();
  const { isAuthenticated, logout, user, getToken } = useAuth();
  
  const [imageScaling, setImageScaling] = useState(0.3);
  const [prefetchCount, setPrefetchCount] = useState(3);
  const [exportRidFilter, setExportRidFilter] = useState("");
  const [ridsList, setRidsList] = useState([]);
  const [isLoadingRids, setIsLoadingRids] = useState(false);
  const [isSaved, setIsSaved] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    if (!isAuthenticated()) {
      navigate("/login");
      return;
    }

    // Load saved scaling value from localStorage
    const savedScaling = localStorage.getItem("imageScaling");
    if (savedScaling) {
      const scalingValue = parseFloat(savedScaling);
      if (!isNaN(scalingValue) && scalingValue >= 0.1 && scalingValue <= 1.0) {
        setImageScaling(scalingValue);
      }
    }

    // Load saved prefetch count from localStorage
    const savedPrefetchCount = localStorage.getItem("prefetchCount");
    if (savedPrefetchCount) {
      const prefetchValue = parseInt(savedPrefetchCount);
      if (!isNaN(prefetchValue) && prefetchValue >= 1 && prefetchValue <= 10) {
        setPrefetchCount(prefetchValue);
      }
    }

    // Fetch list of RIDs
    fetchRidsList();
  }, [navigate, isAuthenticated]);

  const fetchRidsList = async () => {
    setIsLoadingRids(true);
    try {
      const token = getToken();
      
      const response = await fetch(`${config.API_BASE_URL}/api/batch_viewer/list_rids/`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch RIDs: ${response.statusText}`);
      }

      const data = await response.json();
      setRidsList(data.rids || []);
      
    } catch (error) {
      console.error("Error fetching RIDs:", error);
      // Don't show alert, just log the error
    } finally {
      setIsLoadingRids(false);
    }
  };

  const handleScalingChange = (e) => {
    const value = parseFloat(e.target.value);
    setImageScaling(value);
    setIsSaved(false);
  };

  const handlePrefetchCountChange = (e) => {
    const value = parseInt(e.target.value);
    setPrefetchCount(value);
    setIsSaved(false);
  };

  const handleSave = () => {
    localStorage.setItem("imageScaling", imageScaling.toString());
    localStorage.setItem("prefetchCount", prefetchCount.toString());
    setIsSaved(true);
    setTimeout(() => setIsSaved(false), 3000);
  };

  const handleReset = () => {
    setImageScaling(0.3);
    setPrefetchCount(3);
    localStorage.setItem("imageScaling", "0.3");
    localStorage.setItem("prefetchCount", "3");
    setIsSaved(true);
    setTimeout(() => setIsSaved(false), 3000);
  };

  const handleDownloadBatches = async () => {
    // Validate that user has selected something
    if (!exportRidFilter) {
      alert("Please select a RID before downloading.");
      return;
    }

    setIsDownloading(true);
    try {
      const token = getToken();
      
      // Build URL with RID filter (no "all" option anymore)
      const url = `${config.API_BASE_URL}/api/batch_viewer/download_batches/?rid_name=${encodeURIComponent(exportRidFilter)}`;
      
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
        },
      });

      if (response.status === 404) {
        const errorData = await response.json();
        alert(errorData.detail || `RID "${exportRidFilter}" not found or has no batches.`);
        return;
      }

      if (!response.ok) {
        throw new Error(`Failed to download batches: ${response.statusText}`);
      }

      // Get the blob from response
      const blob = await response.blob();
      
      // Create a download link with RID in filename
      const url_obj = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url_obj;
      
      const dateStr = new Date().toISOString().split('T')[0];
      const filename = `batches_${exportRidFilter}_${dateStr}.xlsx`;
      
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      
      // Cleanup
      window.URL.revokeObjectURL(url_obj);
      document.body.removeChild(a);
      
      // Show success notification
      setIsSaved(true);
      setTimeout(() => setIsSaved(false), 3000);
      
    } catch (error) {
      console.error("Error downloading batches:", error);
      alert(`Failed to download batches: ${error.message}`);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header */}
      <div className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-4xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <SettingsIcon className="w-6 h-6 text-gray-700" />
              <h1 className="text-2xl font-semibold text-gray-800">Settings</h1>
            </div>
            <div className="flex items-center gap-3">
              {user && (
                <span className="text-sm text-gray-600">{user.email}</span>
              )}
              <button
                onClick={() => navigate("/")}
                className="flex items-center gap-2 px-4 py-2 text-sm bg-gray-500 hover:bg-gray-600 text-white rounded transition-colors"
                title="Back to Home"
              >
                <Home className="w-4 h-4" />
                Home
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Success Notification */}
      {isSaved && (
        <div className="fixed top-4 right-4 bg-green-500 text-white px-6 py-3 rounded-lg shadow-lg z-50 flex items-center gap-2 animate-fade-in">
          <Save className="w-5 h-5" />
          {isDownloading ? "Batches downloaded successfully!" : "Settings saved successfully!"}
        </div>
      )}

      {/* Settings Content */}
      <div className="max-w-4xl mx-auto px-6 py-8">
        <div className="bg-white rounded-lg shadow-md p-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-6">
            Image Display Settings
          </h2>

          {/* Image Scaling Setting */}
          <div className="space-y-6">
            <div className="border-b border-gray-200 pb-6">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Default Image Scaling (Low-Res Mode)
              </label>
              <p className="text-sm text-gray-500 mb-4">
                Adjust the default scaling for images when viewing in low-res mode. 
                Lower values load faster but with reduced quality.
              </p>

              {/* Slider */}
              <div className="space-y-4">
                <div className="flex items-center gap-4">
                  <span className="text-sm text-gray-600 min-w-[60px]">
                    10%
                  </span>
                  <input
                    type="range"
                    min="0.1"
                    max="1.0"
                    step="0.1"
                    value={imageScaling}
                    onChange={handleScalingChange}
                    className="flex-1 h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-blue-500"
                    style={{
                      background: `linear-gradient(to right, #3b82f6 0%, #3b82f6 ${
                        ((imageScaling - 0.1) / 0.9) * 100
                      }%, #e5e7eb ${((imageScaling - 0.1) / 0.9) * 100}%, #e5e7eb 100%)`,
                    }}
                  />
                  <span className="text-sm text-gray-600 min-w-[60px]">
                    100%
                  </span>
                </div>

                {/* Current Value Display */}
                <div className="flex items-center justify-between bg-blue-50 border border-blue-200 rounded-lg p-4">
                  <div>
                    <p className="text-sm font-medium text-gray-700">
                      Current Scaling
                    </p>
                    <p className="text-xs text-gray-500 mt-1">
                      {imageScaling < 0.3 && "Fastest loading, lowest quality"}
                      {imageScaling >= 0.3 && imageScaling < 0.6 && "Balanced speed and quality"}
                      {imageScaling >= 0.6 && imageScaling < 0.9 && "Slower loading, better quality"}
                      {imageScaling >= 0.9 && "Slowest loading, best quality"}
                    </p>
                  </div>
                  <div className="text-right">
                    <p className="text-3xl font-bold text-blue-600">
                      {Math.round(imageScaling * 100)}%
                    </p>
                    <p className="text-xs text-gray-500">
                      ({imageScaling.toFixed(1)}x)
                    </p>
                  </div>
                </div>

                {/* Quick Presets */}
                <div className="flex gap-2 flex-wrap">
                  <button
                    onClick={() => {
                      setImageScaling(0.3);
                      setIsSaved(false);
                    }}
                    className={`px-3 py-1.5 text-sm rounded transition-colors ${
                      imageScaling === 0.3
                        ? "bg-blue-500 text-white"
                        : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                    }`}
                  >
                    Fast (30%)
                  </button>
                  <button
                    onClick={() => {
                      setImageScaling(0.5);
                      setIsSaved(false);
                    }}
                    className={`px-3 py-1.5 text-sm rounded transition-colors ${
                      imageScaling === 0.5
                        ? "bg-blue-500 text-white"
                        : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                    }`}
                  >
                    Balanced (50%)
                  </button>
                  <button
                    onClick={() => {
                      setImageScaling(0.7);
                      setIsSaved(false);
                    }}
                    className={`px-3 py-1.5 text-sm rounded transition-colors ${
                      imageScaling === 0.7
                        ? "bg-blue-500 text-white"
                        : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                    }`}
                  >
                    Quality (70%)
                  </button>
                  <button
                    onClick={() => {
                      setImageScaling(1.0);
                      setIsSaved(false);
                    }}
                    className={`px-3 py-1.5 text-sm rounded transition-colors ${
                      imageScaling === 1.0
                        ? "bg-blue-500 text-white"
                        : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                    }`}
                  >
                    Maximum (100%)
                  </button>
                </div>
              </div>
            </div>

            {/* Image Prefetch Count Setting */}
            <div className="border-b border-gray-200 pb-6">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Image Prefetch Count
              </label>
              <p className="text-sm text-gray-500 mb-4">
                Set how many upcoming images to preload in the background. 
                Higher values provide smoother navigation but use more memory and bandwidth.
              </p>

              {/* Slider */}
              <div className="space-y-4">
                <div className="flex items-center gap-4">
                  <span className="text-sm text-gray-600 min-w-[60px]">
                    1 image
                  </span>
                  <input
                    type="range"
                    min="1"
                    max="10"
                    step="1"
                    value={prefetchCount}
                    onChange={handlePrefetchCountChange}
                    className="flex-1 h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-green-500"
                    style={{
                      background: `linear-gradient(to right, #10b981 0%, #10b981 ${
                        ((prefetchCount - 1) / 9) * 100
                      }%, #e5e7eb ${((prefetchCount - 1) / 9) * 100}%, #e5e7eb 100%)`,
                    }}
                  />
                  <span className="text-sm text-gray-600 min-w-[60px]">
                    10 images
                  </span>
                </div>

                {/* Current Value Display */}
                <div className="flex items-center justify-between bg-green-50 border border-green-200 rounded-lg p-4">
                  <div>
                    <p className="text-sm font-medium text-gray-700">
                      Current Prefetch Count
                    </p>
                    <p className="text-xs text-gray-500 mt-1">
                      {prefetchCount <= 2 && "Minimal memory usage, less smooth navigation"}
                      {prefetchCount >= 3 && prefetchCount <= 5 && "Balanced performance and memory usage"}
                      {prefetchCount >= 6 && prefetchCount <= 8 && "Higher memory usage, smoother navigation"}
                      {prefetchCount >= 9 && "Maximum memory usage, smoothest navigation"}
                    </p>
                  </div>
                  <div className="text-right">
                    <p className="text-3xl font-bold text-green-600">
                      {prefetchCount}
                    </p>
                    <p className="text-xs text-gray-500">
                      {prefetchCount === 1 ? "image" : "images"}
                    </p>
                  </div>
                </div>

                {/* Quick Presets */}
                <div className="flex gap-2 flex-wrap">
                  <button
                    onClick={() => {
                      setPrefetchCount(1);
                      setIsSaved(false);
                    }}
                    className={`px-3 py-1.5 text-sm rounded transition-colors ${
                      prefetchCount === 1
                        ? "bg-green-500 text-white"
                        : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                    }`}
                  >
                    Minimal (1)
                  </button>
                  <button
                    onClick={() => {
                      setPrefetchCount(3);
                      setIsSaved(false);
                    }}
                    className={`px-3 py-1.5 text-sm rounded transition-colors ${
                      prefetchCount === 3
                        ? "bg-green-500 text-white"
                        : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                    }`}
                  >
                    Balanced (3)
                  </button>
                  <button
                    onClick={() => {
                      setPrefetchCount(5);
                      setIsSaved(false);
                    }}
                    className={`px-3 py-1.5 text-sm rounded transition-colors ${
                      prefetchCount === 5
                        ? "bg-green-500 text-white"
                        : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                    }`}
                  >
                    Smooth (5)
                  </button>
                  <button
                    onClick={() => {
                      setPrefetchCount(10);
                      setIsSaved(false);
                    }}
                    className={`px-3 py-1.5 text-sm rounded transition-colors ${
                      prefetchCount === 10
                        ? "bg-green-500 text-white"
                        : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                    }`}
                  >
                    Maximum (10)
                  </button>
                </div>
              </div>
            </div>

            {/* Batch Export Section */}
            <div className="border-b border-gray-200 pb-6">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Export Batch List
              </label>
              <p className="text-sm text-gray-500 mb-4">
                Download a list of batches in Excel format for a specific RID.
              </p>
              
              <div className="space-y-3">
                {/* Custom RID Dropdown with Search */}
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">
                    Select RID <span className="text-red-500">*</span>
                  </label>
                  <RidDropdown
                    ridsList={ridsList}
                    selectedRid={exportRidFilter}
                    onSelectRid={setExportRidFilter}
                    isDisabled={isDownloading || isLoadingRids}
                    isLoading={isLoadingRids}
                  />
                  <p className="text-xs text-gray-500 mt-1">
                    {isLoadingRids && "Loading RIDs..."}
                    {!isLoadingRids && !exportRidFilter && `Please select a RID from ${ridsList.length} available RID${ridsList.length !== 1 ? 's' : ''}`}
                    {!isLoadingRids && exportRidFilter && `Will download batches from ${exportRidFilter}`}
                  </p>
                </div>

                <button
                  onClick={handleDownloadBatches}
                  disabled={isDownloading || isLoadingRids || !exportRidFilter}
                  className={`w-full flex items-center justify-center gap-2 px-6 py-2.5 rounded-lg font-medium transition-all ${
                    isDownloading || isLoadingRids || !exportRidFilter
                      ? "bg-purple-400 cursor-not-allowed text-white"
                      : "bg-purple-500 hover:bg-purple-600 text-white shadow-md hover:shadow-lg"
                  }`}
                >
                  {isDownloading ? (
                    <>
                      <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                      <span>Downloading...</span>
                    </>
                  ) : (
                    <>
                      <Download className="w-4 h-4" />
                      <span>
                        {!exportRidFilter
                          ? "Select RID to Download"
                          : `Download ${exportRidFilter} Batches`}
                      </span>
                    </>
                  )}
                </button>
                
                {/* Progress Indicator */}
                {isDownloading && (
                  <div className="bg-purple-50 border border-purple-200 rounded-lg p-4 animate-pulse">
                    <div className="flex items-center gap-3">
                      <div className="relative">
                        <div className="w-10 h-10 border-4 border-purple-200 border-t-purple-600 rounded-full animate-spin"></div>
                        <div className="absolute inset-0 flex items-center justify-center">
                          <Download className="w-4 h-4 text-purple-600" />
                        </div>
                      </div>
                      <div className="flex-1">
                        <p className="text-sm font-medium text-purple-900">
                          Fetching batches from {exportRidFilter}...
                        </p>
                        <p className="text-xs text-purple-600 mt-1">
                          This may take a moment for large datasets
                        </p>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Info Box */}
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
              <h3 className="text-sm font-medium text-yellow-800 mb-2">
                ℹ️ Note
              </h3>
              <ul className="text-sm text-yellow-700 space-y-1">
                <li>• Image scaling only affects low-res mode (default view)</li>
                <li>• High-res mode always displays images at 100% quality</li>
                <li>• Prefetch count determines how many upcoming images are loaded in advance</li>
                <li>• Higher prefetch values improve navigation speed but use more memory</li>
                <li>• Changes take effect for newly loaded images</li>
                <li>• Lower scaling = faster loading, less bandwidth usage</li>
                <li>• Batch export creates an Excel file with RID and batch names</li>
                <li>• Use the search box in the dropdown to quickly find specific RIDs</li>
                <li>• You must select a RID before downloading batches</li>
              </ul>
            </div>

            {/* Action Buttons */}
            <div className="flex gap-3 pt-4">
              <button
                onClick={handleSave}
                className="flex items-center gap-2 px-6 py-2.5 bg-blue-500 hover:bg-blue-600 text-white rounded-lg font-medium transition-colors"
              >
                <Save className="w-4 h-4" />
                Save Settings
              </button>
              <button
                onClick={handleReset}
                className="px-6 py-2.5 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-lg font-medium transition-colors"
              >
                Reset to Defaults (30% scaling, 3 prefetch)
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Custom Animations */}
<style jsx>{`
  @keyframes fade-in {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .animate-fade-in {
    animation: fade-in 0.3s ease-out;
  }

  /* Updated scrollbar styles - always visible */
  :global(.scrollbar-visible::-webkit-scrollbar) {
    width: 10px;
  }

  :global(.scrollbar-visible::-webkit-scrollbar-track) {
    background: #f1f5f9;
    border-radius: 4px;
  }

  :global(.scrollbar-visible::-webkit-scrollbar-thumb) {
    background: #a855f7;
    border-radius: 4px;
    border: 2px solid #f1f5f9;
  }

  :global(.scrollbar-visible::-webkit-scrollbar-thumb:hover) {
    background: #9333ea;
  }

  /* For Firefox - always visible */
  :global(.scrollbar-visible) {
    scrollbar-width: thin;
    scrollbar-color: #a855f7 #f1f5f9;
    overflow-y: scroll !important;
  }

  /* Force scrollbar to always show */
  :global(.scrollbar-visible) {
    overflow-y: scroll !important;
  }
`}</style>
    </div>
  );
};

export default Settings;